import { CommonError } from '../../types';
import { ListPriceBoardActions } from './actions';
import { FETCH_LIST_PRICE_BOARD_FAILURE, FETCH_LIST_PRICE_BOARD_REQUEST, FETCH_LIST_PRICE_BOARD_SUCCESS } from './constants';

export interface ListPriceBoardState {
    list: any[]; // Thay bằng kiểu dữ liệu chính xác
    loading: boolean;
    error: CommonError | null;
}

const initialState: ListPriceBoardState = {
    list: [],
    loading: false,
    error: null,
};

export const listPriceBoardReducer = (
    state = initialState,
    action: ListPriceBoardActions
): ListPriceBoardState => {
    switch (action.type) {
        case FETCH_LIST_PRICE_BOARD_REQUEST:
            return { ...state, loading: true, error: null };
        case FETCH_LIST_PRICE_BOARD_SUCCESS:
            return { ...state, loading: false, list: action.payload };
        case FETCH_LIST_PRICE_BOARD_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};
